export const BASE_URL = "https://erp.applified.co.in/jainam/public/api/v1/";
// export const BASE_URL = "http://192.168.1.71:8080/api/v1/";
export const ACCEPT_HEADER = "application/x.jainam.v1+json";

//login
export const login_url = BASE_URL + "login";
export const register_url = BASE_URL + "register";

//dashboard
export const get_form_list_url = BASE_URL + "get-form";
export const selected_list_url = BASE_URL + "select-list";
export const is_select_url = BASE_URL + "is-select";
export const get_merital_status_url = BASE_URL + "get-marital-status";

//profile
export const get_profile_url = BASE_URL + "get-profile";
export const update_profile_url = BASE_URL + "update-profile";
export const delete_brother_url = BASE_URL + "delete-brother";
export const delete_sister_url = BASE_URL + "delete-sister";
export const delete_other_image_url = BASE_URL + "delete-other-image";

//basic data
export const get_caste_url = BASE_URL + "get-cast";
export const get_country_url = BASE_URL + "get-country";
export const get_state_url = BASE_URL + "get-state";
export const get_city_url = BASE_URL + "get-city";
export const get_religion_url = BASE_URL + "get-religion";
export const get_maritialstatus_url = BASE_URL + "get-maritialstatus";

export const delete_user_url = BASE_URL + "delete-user";
export const get_version_url = BASE_URL + "get-version";
